import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';
import {Header, Segment, Container, Loader} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {
  retrieveEntityIdFromPermissionsWithRoleAndType,
  ISOToDisplayDate,
} from 'common/utils';
import {ROLE_MAP, ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {getUniqs} from 'common/utils';
import moment from 'moment-timezone';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {PANEL_SESSIONS_LIST} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

export class SessionsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sessions: [],
      loading: true,
      error: false,
    };
  }

  componentDidMount() {
    //The entityId is the ProgramId from Permissions with EntityType = ENTITY_MAP.PROGRAM.code
    //we want specifically for Role ROLE_MAP.PANELADMIN.code
    document.title = PANEL_SESSIONS_LIST;
    let programId = retrieveEntityIdFromPermissionsWithRoleAndType(
      this.props.auth.permissions,
      ROLE_MAP.PANELADMIN.code,
      ENTITY_MAP.PROGRAM.code
    );
    let today = moment();
    let sessionsList;
    if (programId) {
      this.getSessions(programId)
        .then((sessions) => {
          sessions = _.filter(sessions, function (session) {
            return moment(session.endDate).isSameOrAfter(today);
          });
          sessionsList = sessions;
          return getUniqs(sessions, 'fundingOpportunityId');
        })
        .then((uniqFos) => {
          this.getFoNames(uniqFos)
            .then((foNames) => {
              return _.map(sessionsList, (session) => {
                let newSession;

                newSession = {
                  ...session,
                  foName: _.get(
                    _.find(foNames, (fo) => fo.id === session.fundingOpportunityId),
                    'name'
                  ),
                };
                return newSession;
              });
            })
            .then((sessionsList) => {
              this.setState({
                sessions: sessionsList,
                loading: false,
              });
            });
        });
    }
  }

  getSessions = (programId) => {
    const {auth} = this.props;
    const token = auth.token;

    return REST.panelReviewV2
      .getSessionsByProgramId(token, programId)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({
          error: true,
          loading: false,
        });
      });
  };

  getFoNames = (foIds) => {
    const {auth} = this.props;
    const token = auth.token;

    let foMap = [];
    let promises = [];
    _.forEach(foIds, (id) => {
      let forPromise = new Promise((resolve, reject) => {
        REST.fundingOpportunity
          .getFundingOpportunity(token, id)
          .then(REST.handler.handleResponse)
          .then((res) => {
            foMap = [...foMap, {id: id, name: res.fundingOpportunityName}];
            return resolve();
          })
          .catch((err) => {
            this.setState({
              error: true,
              loading: false,
            });
            return reject;
          });
      });
      promises.push(forPromise);
    });

    return Promise.all(promises).then(() => {
      return foMap;
    });
  };

  renderTable(sessions) {
    const dateTimeConfig = {showDate: true, showHours: true, showTimeZone: true};
    let sortedSessions = _(sessions)
      .chain()
      .sortBy(function (session) {
        return session.sessionId;
      })
      .sortBy(function (session) {
        return session.startDate;
      })
      .value();

    return sortedSessions.map((session) => {
      const startDateStr = ISOToDisplayDate(session.startDate, dateTimeConfig);
      const endDateStr = ISOToDisplayDate(session.endDate, dateTimeConfig);
      const previewDateStr = ISOToDisplayDate(session.previewDate, dateTimeConfig);

      return (
        <FemaGoTable.Row key={session.sessionId}>
          <FemaGoTable.TextCell>
            <Link to={`/panelReview/admin/sessions/${session.sessionId}`}>
              {session.sessionName}
            </Link>
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{session.foName}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{`${startDateStr} - ${endDateStr}`}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{previewDateStr}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{session.location}</FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    });
  }

  render() {
    const {loading, error} = this.state;
    return (
      <Main>
        <Container fluid>
          <Header as="h1">Panel Sessions List</Header>
          {loading ? (
            <Loader inline="centered" active>
              Loading...
            </Loader>
          ) : error ? (
            <p>Error, no session data available at this time.</p>
          ) : _.isEmpty(this.state.sessions) ? (
            <p>No current or upcoming sessions.</p>
          ) : (
            <Segment>
              <FemaGoTable summary="Panel sessions table">
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell>Session name</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Funding opportunity</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Session date</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Preview date</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Location</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body>
                  {this.renderTable(this.state.sessions)}
                </FemaGoTable.Body>
              </FemaGoTable>
            </Segment>
          )}
        </Container>
      </Main>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(SessionsList);
